module.exports = __webpack_public_path__ + "media/images/shared/ad/tunecore01-0eb0ef7a2c0ff0340d88a5638047305c.png";